import axios from 'axios';
import ChildTemplate from '../_/ChildTemplate';
import './initPhoneCall';

const callers = {
  notDefined: 0,
  client: 1,
  partner: 2,
  internal: 3,
};

const types = new Map([
  [0, {
    value: 0,
    label: 'Звонок',
  }],
  [1, {
    value: 1,
    label: 'Ожидание ответа...',
  }],
  [2, {
    value: 2,
    label: 'Звонок начался',
  }],
  [3, {
    value: 3,
    label: 'Звонок завершен',
  }],
]);


export default class extends ChildTemplate {
  show = false;
  id;
  caller = 0;
  type = null;
  label = '';
  external = '';
  number = '';
  preorder = '';
  direction = 0;
  length = 0;
  contact = null;
  lead = null;

  constructor(parent) {
    super(parent);
    this.emitter.on('new', data => this.set(data, types.get(1)));
    this.emitter.on('connected', data => this.set(data, types.get(2)));
    this.emitter.on('disconnected', data => this.set(data, types.get(3)));
    this.emitter.on('close', () => this._close());
  }

  get emitter() {
    return this.emitters.telephony;
  }

  set(data = {}, type) {
    this.type = type || null;
    if (type.value === 1) {
      this.show = true;
    }
    this.id = data.CallIdentifier?.CallId || 0;
    this.external = data.ExternalPhoneName || data.ExternalNumber || '';
    this.caller = data.CallerType;
    this.number = data.ContactPhone;
    this.direction = data.Direction || 0;
    this.contact = data.ContactId
      ? {
        value: data.ContactId,
        label: data.ContactName,
        url: '',
        length: '',
      }
      : null;
    this.lead = data.LeadId
      ? {
        value: data.LeadId,
        label: data.LeadName,
        url: `/tourclient/admin/leads/edit_full.html?id="${data.LeadId}"`,
      }
      : null;
    this.length = (data.Partners?.length || data.Clients?.length || 0);
    this.preorder = '';
    switch (this.caller) {
      case callers.client:
        this.label = data.Direction === 1 ? 'Звонок от клиента' : 'Звонок клиенту';
        if (this.contact) {
          this.contact.url = `/tourclient/admin/clients/edit_full.html?id="${data.ContactId}"`;
          if (data.Clients?.length > 1) {
            this.contact.length = `еще ${data.Clients?.length - 1} клиент(ов)`;
          }
        }
        this.preorder = `/tourclient/admin/preorder/new.html?clientId=${encodeURIComponent(data.ContactId)}`;
        break;
      case callers.partner:
        this.label = data.Direction === 1 ? 'Звонок от партнера' : 'Звонок партнеру';
        if (this.contact) {
          this.contact.url = `/tourclient/admin/partners/edit.html?id="${data.ContactId}"`;
        }
        if (data.Partners?.length > 1) {
          this.contact.length = `еще ${data.Partners?.length - 1} партнер(ов)`;
        }
        break;
      default:
        this.label = data.Direction === 1 ? 'Звонок с неизвестного номера' : 'Звонок на неизвестный номер';
    }
    if (this.lead) {
      this.preorder = `/tourclient/admin/preorder/new.html?leadId=${encodeURIComponent(this.lead.value)}`;
    }
  }

  close() {
    this.emitter.emit('close');
    if (this.id) {
      return axios
        .post('/tourclient/api/Telephony/HangUp', `=${this.id}`)
        .then(({ data }) => data);
    }
    return Promise.resolve();
  }

  _close() {
    this.show = false;
  }
}
